































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

@Component({})
export default class HistoryPage extends Vue {
  get routerHistory() {
    return this.$store.state.user.routerHistory;
  }

  private menuVisible = false; // 右键菜单显示隐藏控制开关
  private rightClickItem: any; // 右键对象
  private showScrollMark = false; // 左右箭头显示隐藏控制开关
  private el: any = ''; // 横向滚动div
  private routerHistoryLength = 0; // 历史路由长度

  private checkedMarginLeft = 2;

  mounted() {
    this.el = document.getElementById('history-page_box');
    window.onresize = () => {
      this.showScroll();
    };
    this.calcCheckedMarginLeft();
  }

  /**
   * @desc 跳转到当前点击路由
   * @param router - 路由对象 {title - 路由名称, path - 路由地址}
   */
  private goHistoryRouter(router: any) {
    if (this.$route.path === router.path) {
      return false;
    }
    this.$router.push(router.path);
  }

  /**
   * @desc 删除当前点击的vuex历史路由
   * @param router - 历史路由对象 {title - 路由名称, path - 路由地址}
   * @param type - 删除类型 self-删除当前点击 left-删除点击左侧 right-删除点击右侧 other-删除除点击外其他 all-删除全部
   */
  deleteHistoryRouter(router: any, type: any) {
    if (router.path === '/index') return
    if (type === 'self' && this.routerHistory.length === 1) return
    const index = this.routerHistory.findIndex((item: any) => item.path === router.path);
    const obj = {
      router,
      type,
      index,
    };
    this.menuVisible = false;
    UserModule.deleteHistoryRouter(obj);

    const indexAfter = this.routerHistory.findIndex((item: any) => item.path === this.$route.path);
    if (indexAfter === -1) {
      switch (type) {
        case 'self':
          this.$router.push(this.routerHistory[index - 1]);
          break;
        case 'left':
        case 'all':
          this.$router.push('/index');
          break;
        case 'right':
        case 'other':
          this.$router.push(router.path);
          break;
      }
    }
    this.calcCheckedMarginLeft();
  }

  private calcCheckedMarginLeft() {
    const checkedRoute = this.$route;
    const index = this.routerHistory.findIndex((item: any) => item.path === checkedRoute.path);
    this.checkedMarginLeft = 20 + (index - 1) * 80 + 85;
  }

  // 监听历史路由变化 控制滚动及左右箭头按钮显示
  @Watch('routerHistory')
  private showScroll() {
    this.$nextTick(() => {
      this.showScrollMark = this.el.scrollWidth > this.el.clientWidth;
      this.$nextTick(() => {
        if (this.routerHistory.length > this.routerHistoryLength) {
          this.el.scrollLeft += 5000;
        }
        this.routerHistoryLength = this.routerHistory.length;
      });
    });
  }

  @Watch('$route')
  private checkedScroll() {
    this.calcCheckedMarginLeft();
  }

  /**
   * @desc 历史路由右键方法
   * @param item - 右键对象数据
   */
  private rightClick(item: any) {
    this.rightClickItem = item;
    this.menuVisible = false;
    this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏

    const menu = document.querySelector('.menu');
    this.styleMenu(menu);
  }

  foo() {
    // 取消鼠标监听事件 菜单栏
    this.menuVisible = false;
    document.removeEventListener('click', this.foo); // 关掉监听，
  }

  styleMenu(menu: any) {
    const event = window.event;
    if ((event as any).clientX > window.innerWidth - 200) {
      menu.style.left = (event as any).clientX - 100 + 'px';
    } else {
      menu.style.left = (event as any).clientX + 1 + 'px';
    }
    document.addEventListener('click', this.foo); // 给整个document新增监听鼠标事件，点击任何位置执行foo方法
    if ((event as any).clientY > 700) {
      menu.style.top = (event as any).clientY - 30 + 'px';
    } else {
      menu.style.top = (event as any).clientY - 10 + 'px';
    }
  }

  /**
   * @desc div滚动控制
   * @param direction - left-点击左箭头 right-点击右箭头
   */
  historyRouterScroll(direction: string) {
    // console.log(this.el);
    if (direction === 'left') {
      this.el.scrollLeft -= 300;
    }
    if (direction === 'right') {
      this.el.scrollLeft += 300;
    }
  }
}
